export default __webpack_public_path__ + "static/media/marketing@2x.1c095055.png";